import React, { useContext, useEffect, useMemo, useState, useRef, useCallback, useLayoutEffect } from "react";
import ReactDOM from "react-dom";
import Card from 'react-bootstrap/Card';
import { Container, Row, Col, Modal, Spinner, Form, InputGroup, Button } from "react-bootstrap";
import { dataContext } from "components/dataContext/dataContext";
import DataTable from 'react-data-table-component';
import '../assets/css/dataTable.css';
import downloadCSV from '../csv/downloadCSV';
import obj from "api/updateDevice";
import getDevice from "api/getDevice";
import getAnydesk from "api/getAnydesk";
import empresas from "api/empresas";
import { AccountContext } from "components/Account/Account";
import createDeviceAPI from "api/createDevice";
import Select from 'react-select';

const DOC_TYPE_OPTIONS = [
  { value: 39, label: 'Boleta' },
  { value: 41, label: 'Boleta Exenta' },
  { value: 33, label: 'Factura' },
  { value: 34, label: 'Factura Exenta' },
  { value: 56, label: 'Nota de Débito' },
  { value: 61, label: 'Nota de Crédito' }
];

const MAX_HEIGHT = 220;
const MIN_HEIGHT = 120;
const GAP = 2;

const rowStyle = { cursor: "pointer", gap: "8px", userSelect: "none" };
const checkboxStyle = { width: "16px", height: "16px", cursor: "pointer" };

const CheckboxRow = ({ label, checked, onChange, header = false }) => (
  <label
    className={`d-flex align-items-center ${header ? "mb-2 font-weight-bold" : "my-1"}`}
    style={rowStyle}
  >
    <input type="checkbox" checked={checked} onChange={onChange} style={checkboxStyle} />
    <span>{label}</span>
  </label>
);

// Select custom adaptativo (Portal + abre hacia arriba si no cabe abajo)
const MultiSelectCheckbox = ({ options, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [pos, setPos] = useState(null);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  const selectedValues = useMemo(() => new Set(value.map((v) => v.value)), [value]);
  const allSelected = options.length > 0 && value.length === options.length;

  const updatePosition = useCallback(() => {
    const rect = buttonRef.current?.getBoundingClientRect();
    if (!rect) return;

    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    const openUpward = spaceBelow < MAX_HEIGHT && spaceAbove > spaceBelow;
    const available = (openUpward ? spaceAbove : spaceBelow) - 10;

    setPos({
      left: rect.left,
      width: rect.width,
      openUpward,
      top: rect.bottom + GAP,
      bottom: window.innerHeight - rect.top + GAP,
      maxHeight: Math.max(MIN_HEIGHT, Math.min(MAX_HEIGHT, available)),
    });
  }, []);

  useLayoutEffect(() => {
    if (!isOpen) return;

    updatePosition();

    const handlePointerDown = (e) => {
      if (!buttonRef.current?.contains(e.target) && !menuRef.current?.contains(e.target)) {
        setIsOpen(false);
      }
    };
    const handleScroll = (e) => {
      // Ignorar el scroll interno del propio menú
      if (e.target instanceof Node && menuRef.current?.contains(e.target)) return;
      updatePosition();
    };

    document.addEventListener("mousedown", handlePointerDown);
    window.addEventListener("scroll", handleScroll, true);
    window.addEventListener("resize", updatePosition);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      window.removeEventListener("scroll", handleScroll, true);
      window.removeEventListener("resize", updatePosition);
    };
  }, [isOpen, updatePosition]);

  const handleSelectAll = () => onChange(allSelected ? [] : [...options]);

  const handleToggleOption = (option) =>
    onChange(
      selectedValues.has(option.value)
        ? value.filter((item) => item.value !== option.value)
        : [...value, option]
    );

  return (
    <div className="w-100">
      <button
        ref={buttonRef}
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="form-control d-flex justify-content-between align-items-center bg-white text-dark"
        style={{ cursor: "pointer", textAlign: "left" }}
      >
        <span>{`${value.length} de ${options.length} seleccionados`}</span>
        <span style={{ fontSize: "10px" }}>{isOpen ? "▲" : "▼"}</span>
      </button>

      {isOpen && pos &&
        ReactDOM.createPortal(
          <div
            ref={menuRef}
            className="bg-white border rounded shadow p-2"
            style={{
              position: "fixed",
              ...(pos.openUpward ? { bottom: pos.bottom } : { top: pos.top }),
              left: pos.left,
              width: pos.width,
              maxHeight: pos.maxHeight,
              overflowY: "auto",
              zIndex: 99999,
            }}
          >
            <CheckboxRow
              header
              label="[Seleccionar todos]"
              checked={allSelected}
              onChange={handleSelectAll}
            />
            <hr className="my-1" />
            {options.map((option) => (
              <CheckboxRow
                key={option.value}
                label={option.label}
                checked={selectedValues.has(option.value)}
                onChange={() => handleToggleOption(option)}
              />
            ))}
          </div>,
          document.body
        )}
    </div>
  );
};

function ListaEquipos() {
  const { data } = useContext(dataContext);
  const { getSession } = useContext(AccountContext);
  const [filtered, setFiltered] = useState([]);
  const [filter, setFilter] = useState('');
  const [dataFiltered, setDataFiltered] = useState(filtered);
  const [showEdit, setShowEdit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingModal, setLoadingModal] = useState(false);
  const [dispositivo, setDispositivo] = useState(false);
  const [dispositivoStatus, setDispositivoStatus] = useState('');
  const [deviceName, setDeviceName] = useState('');
  const [local, setLocal] = useState('');
  const [direccion, setDireccion] = useState('');
  const [ciudad, setCiudad] = useState('');
  const [comuna, setComuna] = useState('');
  const [anydesk, setAnydesk] = useState('');
  const [password, setPassword] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [configGroups, setConfigGroups] = useState([]);
  const [deviceConfigGroupId, setDeviceConfigGroupId] = useState('');
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [showAccess, setShowAccess] = useState(false);
  const [accessAnydesk, setAccessAnydesk] = useState('');
  const [accessPassword, setAccessPassword] = useState('');
  const [accessDeviceId, setAccessDeviceId] = useState('');
  const [accessDeviceName, setAccessDeviceName] = useState('');

  const [modalTitle, setModalTitleLoading] = useState('C2C BOLETAS CLOUD');
  const [message, setMessage] = useState('');
  const [showCreate, setShowCreate] = useState(false);
  const [createGroups, setCreateGroups] = useState([]);
  const [selectedDocTypes, setSelectedDocTypes] = useState([{ value: 39, label: 'Boleta' }]);
  const [newDevice, setNewDevice] = useState({
    tenant_id: '', rut: '', device_id: '', device_name: '', deviceconfiggroup_id: ''
  });
  const [allCompanies, setAllCompanies] = useState([]);
  const uniqueCompanies = useMemo(() => {
    const map = new Map();
    filtered.forEach(d => {
      if (d.tenant_id && !map.has(d.tenant_id)) {
        map.set(d.tenant_id, { tenant_id: d.tenant_id, rut: d.rut, empresa: d.empresa });
      }
    });
    return Array.from(map.values());
  }, [filtered]);

  useEffect(() => {
    try {
      if (data.estado) {
        console.log('Lista Equipos');

        const dataFilter = data.data.filter(e => e.empresa !== undefined).flatMap((e) => {
          let folios;
          try {
            folios = e.folios_disponibles[e.rut]?.[39];
            if (e.folios_disponibles[e.rut]?.[41] !== undefined) {
              folios = `${e.folios_disponibles[e.rut][39]} ; ${e.folios_disponibles[e.rut][41]}`;
            }
          } catch (error) {
            console.error(error);
          }
          return {
            rut: e.rut,
            device_id: e.device_id,
            device_name: e.device_name,
            dias: Math.trunc(e.dias),
            empresa: e.empresa,
            folios_disponibles: Math.trunc(folios),
            status: e.status,
            tenant_id: e.tenant_id,
            local: e.local || '',
            direccion: e.direccion || '',
            ciudad: e.ciudad || '',
            comuna: e.comuna || '',
            anydesk: e.anydesk || '',
            password: e.password || '',
            observaciones: e.observaciones || ''
          };
        });
        setFiltered(dataFilter);
        setDataFiltered(dataFilter);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  }, [data]);

  const handleChange = (e) => {
    e.preventDefault();
    setFilter(e.target.value);
    const searchValue = e.target.value.toLowerCase();
    try {
      const aux = filtered.filter((element) => {
        const { rut, empresa, device_id, device_name, dias, folios_disponibles } = element;
        return (
          (rut && rut.trim().includes(searchValue)) ||
          (empresa && empresa.toLowerCase().trim().includes(searchValue)) ||
          (device_id && device_id.toLowerCase().trim().includes(searchValue)) ||
          (device_name && device_name.toLowerCase().trim().includes(searchValue)) ||
          (typeof dias === 'number' && dias.toString().includes(searchValue)) ||
          (typeof folios_disponibles === 'number' && folios_disponibles.toString().includes(searchValue))
        );
      });
      setDataFiltered(aux);
      if (aux.length === 0) {
      }
    } catch (error) {
    }
  };

  const editardispositivo = async (row) => {
    setShowLoadingModal(true);
    setLoadingModal(true);
    setMessage('');

    try {
      const idToken = await getSession().then((session) => session.idToken.jwtToken);
      const [deviceResp, groupsResp] = await Promise.all([
        getDevice(idToken, row.tenant_id, row.device_id),
        empresas.getDeviceConfigGroups(row.tenant_id, idToken),
      ]);
      const deviceData = deviceResp?.data?.data || deviceResp?.data || {};
      const groupsData = Array.isArray(groupsResp?.data)
        ? groupsResp.data
        : (groupsResp?.data?.items || []);

      const dispositivoInfo = {
        rut: row.rut,
        empresa: row.empresa,
        device_id: row.device_id,
        device_name: deviceData.device_name ?? row.device_name,
        dias: Math.trunc(row.dias),
        status: deviceData.status ?? row.status,
        folios_disponibles: row.folios_disponibles,
        tenant_id: row.tenant_id,
        local: deviceData.local ?? '',
        direccion: deviceData.direccion ?? '',
        ciudad: deviceData.ciudad ?? '',
        comuna: deviceData.comuna ?? '',
        anydesk: deviceData.anydesk ?? '',
        password: deviceData.password ?? '',
        observaciones: deviceData.observaciones ?? '',
        deviceconfiggroup_id: deviceData.deviceconfiggroup_id ?? ''
      };

      setDispositivo(dispositivoInfo);
      setDispositivoStatus(dispositivoInfo.status);
      setDeviceName(dispositivoInfo.device_name);
      setLocal(dispositivoInfo.local);
      setDireccion(dispositivoInfo.direccion);
      setCiudad(dispositivoInfo.ciudad);
      setComuna(dispositivoInfo.comuna);
      setAnydesk(dispositivoInfo.anydesk);
      setPassword(dispositivoInfo.password);
      setObservaciones(dispositivoInfo.observaciones);
      setConfigGroups(groupsData);
      setDeviceConfigGroupId(dispositivoInfo.deviceconfiggroup_id);

      setLoadingModal(false);
      setShowLoadingModal(false);
      setShowEdit(true);
    } catch (error) {
      console.error('Error al obtener el dispositivo:', error);
      setLoadingModal(false);
      setMessage('Error al obtener la información del dispositivo. Por favor, inténtelo de nuevo.');
    }
  };

  const verAcceso = async (row) => {
    setShowLoadingModal(true);
    setLoadingModal(true);
    setMessage('');

    try {
      const idToken = await getSession().then((session) => session.idToken.jwtToken);
      const response = await getAnydesk(idToken, row.tenant_id, row.device_id);
      const deviceData = response?.data?.data || response?.data || {};

      setAccessDeviceId(row.device_id);
      setAccessDeviceName(deviceData.device_name ?? row.device_name ?? '');
      setAccessAnydesk(deviceData.anydesk ?? row.anydesk ?? '');
      setAccessPassword(deviceData.password ?? row.password ?? '');

      setLoadingModal(false);
      setShowLoadingModal(false);
      setShowAccess(true);
    } catch (error) {
      console.error('Error al obtener el dispositivo:', error);
      setLoadingModal(false);
      setMessage('Error al obtener la información del dispositivo. Por favor, inténtelo de nuevo.');
    }
  };

  const validarCampos = () => {
    if (!deviceName || !deviceName.trim()) {
      return 'El nombre del dispositivo es obligatorio.';
    }
    if (!deviceConfigGroupId) {
      return 'Debe seleccionar un grupo de configuración.';
    }
    if (deviceName.length > 100) {
      return 'El nombre del dispositivo no puede superar los 100 caracteres.';
    }
    if (local.length > 100) {
      return 'El campo Local no puede superar los 100 caracteres.';
    }
    if (direccion.length > 70) {
      return 'El campo Dirección no puede superar los 70 caracteres.';
    }
    if (ciudad.length > 20) {
      return 'El campo Ciudad no puede superar los 20 caracteres.';
    }
    if (comuna.length > 20) {
      return 'El campo Comuna no puede superar los 20 caracteres.';
    }
    if (observaciones.length > 150) {
      return 'El campo Observaciones no puede superar los 150 caracteres.';
    }
    return null;
  };

  const guardarCambios = async (event) => {
    event.preventDefault();

    const errorValidacion = validarCampos();
    if (errorValidacion) {
      setShowEdit(false);
      setShowLoadingModal(true);
      setLoadingModal(false);
      setMessage(errorValidacion);
      return;
    }

    const dispositivoActualizado = {
      ...dispositivo,
      device_name: deviceName,
      status: dispositivoStatus,
      local,
      direccion,
      ciudad,
      comuna,
      anydesk,
      password,
      observaciones,
      deviceconfiggroup_id: deviceConfigGroupId
    };

    try {
      setShowEdit(false);
      setShowLoadingModal(true);
      setLoadingModal(true);

      const idToken = await getSession().then((session) => session.idToken.jwtToken);
      await obj.updateDevice(idToken, dispositivoActualizado);
      setMessage('Dispositivo actualizado exitosamente.');

      const updatedDataFiltered = dataFiltered.map((item) =>
        item.device_id === dispositivoActualizado.device_id ? dispositivoActualizado : item
      );
      setDataFiltered(updatedDataFiltered);

    } catch (error) {
      console.error('Error al guardar el dispositivo:', error);
      setMessage('Error al actualizar el dispositivo. Por favor, inténtelo de nuevo.');
    } finally {
      setLoadingModal(false);
    }
  };

  const stats = useMemo(() => {
    const total = filtered.length;
    let activos = 0;
    let inactivos = 0;
    filtered.forEach((d) => {
      if (d.status === 'active') activos += 1;
      else inactivos += 1;
    });
    return { total, activos, inactivos };
  }, [filtered]);

  const statusLabel = (status) => {
    if (status === 'active') return 'Activo';
    if (status === 'disabled') return 'Inactivo';
    return 'Suspendido';
  };

  const statusVariant = (status) => {
    if (status === 'active') return 'success';
    if (status === 'disabled') return 'danger';
    return 'warning';
  };

  const columns = [
    {
      name: 'Rut',
      selector: row => row.rut,
      sortable: true,
      width: '8%',
    },
    {
      name: 'Cliente',
      selector: row => row.empresa,
      sortable: true,
    },
    {
      name: 'ID Dispositivo',
      selector: row => row.device_id,
      sortable: true,
    },
    {
      name: 'Nombre Dispositivo',
      selector: row => row.device_name,
      sortable: true,
    },
    {
      name: 'Última Conexión',
      selector: row => Math.trunc(row.dias),
      sortable: true,
      width: '12%',
    },
    {
      name: 'Folios Disponibles',
      selector: row => row.folios_disponibles,
      sortable: true,
      width: '12%',
    },
    {
      name: 'Estado',
      selector: row => row.status,
      cell: row => (
        <span className={`status-badge status-badge--${statusVariant(row.status)}`}>
          {statusLabel(row.status)}
        </span>
      ),
      sortable: true,
      width: '12%',
    },
    {
      name: "Acciones",
      cell: (row) => (
        <div className="row-actions">
          <Button
            size="sm"
            className="btn-row btn-row--edit"
            onClick={() => editardispositivo(row)}
          >
            Editar
          </Button>
          <Button
            size="sm"
            className="btn-row btn-row--access"
            onClick={() => verAcceso(row)}
          >
            Acceso
          </Button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '180px',
    },
  ];

  const paginationOpciones = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsText: 'Todos'
  };

  const handleExport = () => downloadCSV(dataFiltered);
  const handleOpenCreate = () => {
    setShowCreate(true);
    setCreateGroups([]);
    setSelectedDocTypes([{ value: 39, label: 'Boleta' }]);
    setNewDevice({
      tenant_id: '', rut: '', device_id: '', device_name: '', deviceconfiggroup_id: ''
    });
    getSession().then((session) => {
      const token = session.idToken.jwtToken;
      empresas.getEmpresas(token).then((res) => {
        const sortedcompanies = res.data.sort((a, b) => {
          const companieA = a.name?.toLowerCase() || "";
          const companieB = b.name?.toLowerCase() || "";
          return companieA.localeCompare(companieB);
        });
        setAllCompanies(sortedcompanies);
      }).catch((err) => console.error(err));
    });
  };

  const guardarNuevaCaja = async (e) => {
    e.preventDefault();

    if (!newDevice.tenant_id || !newDevice.device_name) {
      alert("Por favor complete los campos de Empresa y Nombre del dispositivo.");
      return;
    }

    if (!newDevice.deviceconfiggroup_id && (!selectedDocTypes || selectedDocTypes.length === 0)) {
      alert("Por favor seleccione al menos un tipo de documento para Cajas Virtuales.");
      return;
    }

    try {
      setShowCreate(false);
      setShowLoadingModal(true);
      setLoadingModal(true);

      const idToken = await getSession().then(s => s.idToken.jwtToken);

      const payload = {
        ...newDevice,
        ...(!newDevice.deviceconfiggroup_id && {
          tiposdocumento: selectedDocTypes.map(item => item.value)
        })
      };

      await createDeviceAPI(idToken, payload);

      setMessage('Caja virtual creada exitosamente. Actualice la página para verla en la lista.');
    } catch (err) {
      setMessage('Error al crear la caja virtual.');
    } finally {
      setLoadingModal(false);
    }
  };

  return (
    <Container fluid className="page-container">
      <div className="page-header">
        <div>
          <h2 className="page-title">Lista de Equipos</h2>
          <p className="page-subtitle">
            Última actualización: {data.lastcheck || '—'}
          </p>
        </div>
      </div>

      <Row className="stats-row">
        <Col xs={12} sm={6} lg={4}>
          <div className="stat-card stat-card--info">
            <div className="stat-card__icon"><i className="nc-icon nc-notes" /></div>
            <div className="stat-card__content">
              <span className="stat-card__label">Total equipos</span>
              <span className="stat-card__value">{stats.total}</span>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} lg={4}>
          <div className="stat-card stat-card--success">
            <div className="stat-card__icon"><i className="nc-icon nc-check-2" /></div>
            <div className="stat-card__content">
              <span className="stat-card__label">Activos</span>
              <span className="stat-card__value">{stats.activos}</span>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} lg={4}>
          <div className="stat-card stat-card--danger">
            <div className="stat-card__icon"><i className="nc-icon nc-simple-remove" /></div>
            <div className="stat-card__content">
              <span className="stat-card__label">Inactivos / Suspendidos</span>
              <span className="stat-card__value">{stats.inactivos}</span>
            </div>
          </div>
        </Col>
      </Row>

      <Card className="data-card">
        <Card.Body>
          <div className="data-card__toolbar">
            <div className="search-input">
              <i className="nc-icon nc-zoom-split" />
              <input
                type="text"
                name="search"
                value={filter}
                autoComplete="off"
                placeholder="Filtrar por rut, empresa, dispositivo..."
                onChange={handleChange}
              />
            </div>
            <Button variant="primary" className="btn-create mr-2" onClick={handleOpenCreate}>
              <i className="nc-icon nc-simple-add" /> Crear caja virtual
            </Button>
            <Button className="btn-export" onClick={handleExport}>
              <i className="nc-icon nc-cloud-download-93" />
              Exportar CSV
            </Button>
          </div>
          <DataTable
            className="-striped -highlight"
            fixedHeader={true}
            columns={columns}
            data={dataFiltered}
            pagination
            progressPending={loading}
            paginationComponentOptions={paginationOpciones}
          />
        </Card.Body>
      </Card>

      <Modal show={showEdit} onHide={() => setShowEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar dispositivo</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {!loading && dispositivo && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Empresa</Form.Label>
                <Form.Control value={dispositivo.empresa} disabled />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>ID Dispositivo</Form.Label>
                <Form.Control value={dispositivo.device_id} disabled />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                  value={deviceName}
                  onChange={(e) => setDeviceName(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Estado</Form.Label>
                <Form.Control as="select"
                  value={dispositivoStatus}
                  onChange={(e) => setDispositivoStatus(e.target.value)}
                >
                  <option value="active">Activo</option>
                  <option value="disabled">Inactivo</option>
                  <option value="suspended">Suspendido</option>
                </Form.Control>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Local</Form.Label>
                <Form.Control
                  value={local}
                  maxLength={100}
                  onChange={(e) => setLocal(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Dirección</Form.Label>
                <Form.Control
                  value={direccion}
                  maxLength={70}
                  onChange={(e) => setDireccion(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Ciudad</Form.Label>
                <Form.Control
                  value={ciudad}
                  maxLength={20}
                  onChange={(e) => setCiudad(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Comuna</Form.Label>
                <Form.Control
                  value={comuna}
                  maxLength={20}
                  onChange={(e) => setComuna(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>AnyDesk</Form.Label>
                <Form.Control
                  value={anydesk}
                  onChange={(e) => setAnydesk(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Grupo de configuración</Form.Label>
                <Form.Control
                  as="select"
                  value={deviceConfigGroupId || ''}
                  onChange={(e) => setDeviceConfigGroupId(e.target.value)}
                >
                  <option value="" disabled>Seleccione un grupo</option>
                  {configGroups.map((g) => (
                    <option key={g.deviceconfiggroup_id} value={g.deviceconfiggroup_id}>
                      {g.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Observaciones</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={observaciones}
                  maxLength={150}
                  onChange={(e) => setObservaciones(e.target.value)}
                />
              </Form.Group>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEdit(false)}>
            Cerrar
          </Button>
          <Button variant="success" onClick={guardarCambios}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showAccess} onHide={() => setShowAccess(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Acceso del dispositivo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>ID Dispositivo</Form.Label>
            <Form.Control value={accessDeviceId} disabled />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Nombre Dispositivo</Form.Label>
            <Form.Control value={accessDeviceName} disabled />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>AnyDesk</Form.Label>
            <InputGroup>
              <Form.Control value={accessAnydesk} readOnly />
              <Button
                variant="outline-secondary"
                onClick={() => navigator.clipboard.writeText(accessAnydesk)}
                disabled={!accessAnydesk}
              >
                Copiar
              </Button>
            </InputGroup>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <InputGroup>
              <Form.Control value={accessPassword} readOnly />
              <Button
                variant="outline-secondary"
                onClick={() => navigator.clipboard.writeText(accessPassword)}
                disabled={!accessPassword}
              >
                Copiar
              </Button>
            </InputGroup>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAccess(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showLoadingModal} onHide={() => setShowLoadingModal(false)}>
        <Modal.Header>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingModal && <Spinner animation="border" role="status" className='sticky-top'></Spinner>}
          <p>{!loadingModal && <> {message} </>}</p>
        </Modal.Body>
        <Modal.Footer>
          {!loadingModal &&
            <Button variant="secondary" onClick={() => setShowLoadingModal(false)}>
              Cerrar
            </Button>
          }
        </Modal.Footer>
      </Modal>

      <Modal show={showCreate} onHide={() => setShowCreate(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Crear Caja Virtual</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ minHeight: '360px' }}>
          <Form.Group className="mb-3">
            <Form.Label>Empresa</Form.Label>
            <Select
              options={(allCompanies.length > 0 ? allCompanies : uniqueCompanies).map(c => ({
                value: c.tenant_id,
                label: `${c.rut} - ${c.name || c.empresa || 'Sin nombre'}`,
                rut: c.rut
              }))}
              placeholder="Selecciona una empresa..."
              noOptionsMessage={() => "No se encontraron empresas"}
              onChange={async (opcionSeleccionada) => {
                const tenant_id = opcionSeleccionada.value;
                setNewDevice(prev => ({
                  ...prev,
                  tenant_id: tenant_id,
                  rut: opcionSeleccionada.rut,
                  deviceconfiggroup_id: ''
                }));

                try {
                  const idToken = await getSession().then((s) => s.idToken.jwtToken);
                  const groupsResp = await empresas.getDeviceConfigGroups(tenant_id, idToken);
                  const groupsData = Array.isArray(groupsResp?.data) ? groupsResp.data : (groupsResp?.data?.items || []);
                  setCreateGroups(groupsData);
                } catch (error) {
                  console.error('Error al cargar grupos:', error);
                }
              }}
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />

            <datalist id="opcionesEmpresas">
              {uniqueCompanies.map(c => (
                <option key={c.tenant_id} value={`${c.empresa} (${c.rut})`} />
              ))}
            </datalist>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Nombre Dispositivo</Form.Label>
            <Form.Control
              value={newDevice.device_name}
              onChange={(e) => setNewDevice({ ...newDevice, device_name: e.target.value })}
              placeholder="ej: Caja Nube Las Condes"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Grupo de Configuración</Form.Label>
            <Form.Control
              as="select"
              value={newDevice.deviceconfiggroup_id || ''}
              onChange={(e) => setNewDevice({ ...newDevice, deviceconfiggroup_id: e.target.value })}
            >
              <option value="">Cajas Virtuales (predeterminado)</option>
              {createGroups.map((g) => (
                <option key={g.deviceconfiggroup_id} value={g.deviceconfiggroup_id}>
                  {g.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          {!newDevice.deviceconfiggroup_id && (
            <Form.Group className="mb-3">
              <Form.Label>Tipos de Documento</Form.Label>
              <MultiSelectCheckbox
                options={DOC_TYPE_OPTIONS}
                value={selectedDocTypes}
                onChange={setSelectedDocTypes}
              />
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCreate(false)}>Cancelar</Button>
          <Button variant="success" onClick={guardarNuevaCaja}>Crear Caja</Button>
        </Modal.Footer>
      </Modal>

    </Container>
  );
}

export default ListaEquipos;